import { render, staticRenderFns } from "./CorporateCulture.vue?vue&type=template&id=a65a181c&scoped=true&"
import script from "./CorporateCulture.vue?vue&type=script&lang=js&"
export * from "./CorporateCulture.vue?vue&type=script&lang=js&"
import style0 from "./CorporateCulture.vue?vue&type=style&index=0&id=a65a181c&scoped=true&lang=css&"
import style1 from "./CorporateCulture.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65a181c",
  null
  
)

export default component.exports